import { Box } from "@mui/material";
import UserForm from "../components/forms/userForm.component";
import { useDispatch, useSelector } from "react-redux";
import { createUserStart } from "../store/features/user/userSlice";
import { defaultAddress } from "../components/forms/utils";
import CustomAlert from "../components/alert/alert.component";
import { getErrorMessage } from "../utils/errorUtils";

const cleanUserData = (data) => {
  const cleaned = { ...data };

  ["legal_address", "administrative_address"].forEach((field) => {
    if (Object.values(cleaned[field] || {}).every((v) => v === "")) {
      delete cleaned[field];
    }
  });

  return cleaned;
};

const AddUserPage = () => {
  const dispatch = useDispatch();

  const access_token = useSelector((state) => state.auth?.user?.access_token);
  const { isLoading, error, success } = useSelector((state) => state.user);
  const defaultValues = {
    company_name: "",
    email: "",
    legal_address: { ...defaultAddress },
    administrative_address: { ...defaultAddress },
  };
  const onSubmit = (data) => {
    const cleanedData = cleanUserData(data);
    dispatch(createUserStart({ data: cleanedData, accessToken: access_token }));
  };
  return (
    <Box width="100%" height="100%" overflow="auto">
      {error && (
        <CustomAlert
          severity="error"
          message={getErrorMessage(error, {
            fallback: "Errore durante la creazione dell'utente.",
          })}
        />
      )}
      <UserForm
        mode="create"
        onSubmit={onSubmit}
        isLoading={isLoading}
        error={error}
        success={success}
        defaultValues={defaultValues}
      />
    </Box>
  );
};

export default AddUserPage;
